import React from "react";
import { LANGUAGE_COUNT, LANGUAGE_FEATURES, LANGUAGE_GROUPS, NOTE } from "../data/voiceLanguages";
import "./VoiceLanguages.css";

// Sales and Voice Agent page: the languages the voice agent can be configured to speak.
function VoiceLanguages() {
  return (
    <section className="voice-lang-section" id="languages">
      <div className="container">
        <div className="voice-lang-heading">
          <div><div className="eyebrow section-eyebrow">Languages</div><h2>Speaks your customers’ language. <span>{LANGUAGE_COUNT}+ languages.</span></h2></div>
          <p>Serve callers in Hindi, Gujarati and other Indian languages, in English with familiar accents, and in major international languages, all from one voice agent.</p>
        </div>
        <div className="voice-lang-groups">
          {LANGUAGE_GROUPS.map((group) => (
            <div className={`voice-lang-group is-${group.key}`} key={group.key}>
              <h3>{group.title}<span>{group.languages.length}</span></h3>
              <div>{group.languages.map((language) => <span className="voice-lang-pill" key={language}>{language}</span>)}</div>
            </div>
          ))}
        </div>
        <div className="voice-lang-features">
          {LANGUAGE_FEATURES.map((feature) => <article key={feature.title}><span aria-hidden="true">✓</span><div><h4>{feature.title}</h4><p>{feature.text}</p></div></article>)}
        </div>
        <p className="voice-lang-note">{NOTE}</p>
      </div>
    </section>
  );
}

export default VoiceLanguages;
